import type { Abilities, AnyAbility, CanParameters } from '@casl/ability'
import { createContextualCan } from '@casl/react'
import { type Context, createContext, use, useMemo } from 'react'

export const AbilityContext = createContext<AnyAbility>(null as never)

export function buildAbilityContext<TAbility extends AnyAbility, TAbilities extends Abilities>() {
  const useAbility = () => use(AbilityContext)
  const Can = createContextualCan<TAbility>(AbilityContext.Consumer)

  const useCan = (
    action: CanParameters<TAbilities>[0],
    subject: CanParameters<TAbilities>[1],
    field?: string,
    debug?: boolean,
  ) => {
    const ability = useAbility()
    return useMemo(() => {
      return ability.can(action, subject, field, debug)
    }, [ability, action, subject, field, debug])
  }

  return {
    AbilityContext: AbilityContext as never as Context<TAbility>,
    useAbility,
    Can,
    useCan,
  }
}
